import React from "react";
import { ErrorMessage } from "formik";
import { Icon } from "@shared/components/Icon";

import "./index.scss";

interface ErrorMessageAlertProps {
  name: string;
}

const ErrorMessageAlert = (props: ErrorMessageAlertProps) => (
  <ErrorMessage
    name={props.name}
    render={(msg) => (
      <div className="error-msg-alert">
        <Icon className="error-msg-alert-icon" type="warn" />
        <span className="error-msg-alert-content">{msg}</span>
      </div>
    )}
  />
);

export default ErrorMessageAlert;
